/*
 * =====================================================================================
 * DISCLAIMER:
 * =====================================================================================
 * This localization file is a community contribution and is not officially maintained
 * by Clerk. It has been provided by the community and may not be fully aligned
 * with the current or future states of the main application. Clerk does not guarantee
 * the accuracy, completeness, or timeliness of the translations in this file.
 * Use of this file is at your own risk and discretion.
 * =====================================================================================
 */

import type { LocalizationResource } from '@clerk/types';

export const msMY: LocalizationResource = {
  locale: 'ms-MY',
  apiKeys: {
    action__add: undefined,
    action__search: undefined,
    createdAndExpirationStatus__expiresOn: undefined,
    createdAndExpirationStatus__never: undefined,
    detailsTitle__emptyRow: undefined,
    formButtonPrimary__add: undefined,
    formFieldCaption__expiration__expiresOn: undefined,
    formFieldCaption__expiration__never: undefined,
    formFieldOption__expiration__180d: undefined,
    formFieldOption__expiration__1d: undefined,
    formFieldOption__expiration__1y: undefined,
    formFieldOption__expiration__30d: undefined,
    formFieldOption__expiration__60d: undefined,
    formFieldOption__expiration__7d: undefined,
    formFieldOption__expiration__90d: undefined,
    formFieldOption__expiration__never: undefined,
    formHint: undefined,
    formTitle: undefined,
    lastUsed__days: undefined,
    lastUsed__hours: undefined,
    lastUsed__minutes: undefined,
    lastUsed__months: undefined,
    lastUsed__seconds: undefined,
    lastUsed__years: undefined,
    menuAction__revoke: undefined,
    revokeConfirmation: {
      confirmationText: undefined,
      formButtonPrimary__revoke: undefined,
      formHint: undefined,
      formTitle: undefined,
    },
  },
  backButton: 'Kembali',
  badge__activePlan: undefined,
  badge__canceledEndsAt: undefined,
  badge__currentPlan: 'Pelan Semasa',
  badge__default: 'Lalai',
  badge__endsAt: undefined,
  badge__expired: 'Tamat tempoh',
  badge__otherImpersonatorDevice: 'Peranti penyamar lain',
  badge__pastDueAt: undefined,
  badge__pastDuePlan: undefined,
  badge__primary: 'Utama',
  badge__renewsAt: undefined,
  badge__requiresAction: 'Memerlukan tindakan',
  badge__startsAt: undefined,
  badge__thisDevice: 'Peranti ini',
  badge__unverified: 'Belum disahkan',
  badge__upcomingPlan: undefined,
  badge__userDevice: 'Peranti pengguna',
  badge__you: 'Anda',
  commerce: {
    addPaymentMethod: undefined,
    alwaysFree: undefined,
    annually: undefined,
    availableFeatures: undefined,
    billedAnnually: 'Dibilkan secara tahunan',
    billedMonthlyOnly: undefined,
    cancelSubscription: undefined,
    cancelSubscriptionAccessUntil: undefined,
    cancelSubscriptionNoCharge: undefined,
    cancelSubscriptionTitle: undefined,
    cannotSubscribeMonthly: undefined,
    cannotSubscribeUnrecoverable: undefined,
    checkout: {
      description__paymentSuccessful: undefined,
      description__subscriptionSuccessful: undefined,
      downgradeNotice: undefined,
      emailForm: {
        subtitle: undefined,
        title: undefined,
      },
      lineItems: {
        title__paymentMethod: undefined,
        title__statementId: undefined,
        title__subscriptionBegins: undefined,
        title__totalPaid: undefined,
      },
      pastDueNotice: undefined,
      perMonth: undefined,
      title: undefined,
      title__paymentSuccessful: undefined,
      title__subscriptionSuccessful: undefined,
    },
    credit: undefined,
    creditRemainder: undefined,
    defaultFreePlanActive: undefined,
    free: 'Percuma',
    getStarted: 'Mulakan',
    keepSubscription: undefined,
    manage: undefined,
    manageSubscription: 'Urus keahlian',
    month: 'Bulan',
    monthly: undefined,
    pastDue: undefined,
    pay: undefined,
    paymentMethods: undefined,
    paymentSource: {
      applePayDescription: {
        annual: undefined,
        monthly: undefined,
      },
      dev: {
        anyNumbers: undefined,
        cardNumber: undefined,
        cvcZip: undefined,
        developmentMode: undefined,
        expirationDate: undefined,
        testCardInfo: undefined,
      },
    },
    popular: undefined,
    pricingTable: {
      billingCycle: undefined,
      included: undefined,
    },
    reSubscribe: undefined,
    seeAllFeatures: undefined,
    subscribe: undefined,
    subscriptionDetails: {
      beginsOn: undefined,
      currentBillingCycle: undefined,
      endsOn: undefined,
      nextPaymentAmount: undefined,
      nextPaymentOn: undefined,
      pastDueAt: undefined,
      renewsAt: undefined,
      subscribedOn: undefined,
      title: undefined,
    },
    subtotal: undefined,
    switchPlan: 'Tukar ke pelan ini',
    switchToAnnual: undefined,
    switchToAnnualWithAnnualPrice: undefined,
    switchToMonthly: undefined,
    switchToMonthlyWithPrice: undefined,
    totalDue: undefined,
    totalDueToday: undefined,
    viewFeatures: undefined,
    viewPayment: undefined,
    year: undefined,
  },
  createOrganization: {
    formButtonSubmit: 'Cipta organisasi',
    invitePage: {
      formButtonReset: 'Langkau',
    },
    title: 'Cipta organisasi',
  },
  dates: {
    lastDay: "Semalam pada {{ date | timeString('ms-MY') }}",
    next6Days: "{{ date | weekday('ms-MY','long') }} pada {{ date | timeString('ms-MY') }}",
    nextDay: "Esok pada {{ date | timeString('ms-MY') }}",
    numeric: "{{ date | numeric('ms-MY') }}",
    previous6Days: "{{ date | weekday('ms-MY','long') }} lepas pada {{ date | timeString('ms-MY') }}",
    sameDay: "Hari ini pada {{ date | timeString('ms-MY') }}",
  },
  dividerText: 'atau',
  footerActionLink__alternativePhoneCodeProvider: undefined,
  footerActionLink__useAnotherMethod: 'Gunakan kaedah lain',
  footerPageLink__help: 'Bantuan',
  footerPageLink__privacy: 'Privasi',
  footerPageLink__terms: 'Terma',
  formButtonPrimary: 'Teruskan',
  formButtonPrimary__verify: 'Sahkan',
  formFieldAction__forgotPassword: 'Lupa kata laluan?',
  formFieldError__matchingPasswords: 'Kata laluan sepadan.',
  formFieldError__notMatchingPasswords: 'Kata laluan tidak sepadan.',
  formFieldError__verificationLinkExpired: 'Pautan pengesahan telah tamat tempoh. Sila minta pautan baharu.',
  formFieldHintText__optional: 'Pilihan',
  formFieldHintText__slug: 'Slug adalah ID mesra manusia yang mestilah unik. Ia sering digunakan dalam URL.',
  formFieldInputPlaceholder__apiKeyDescription: undefined,
  formFieldInputPlaceholder__apiKeyExpirationDate: undefined,
  formFieldInputPlaceholder__apiKeyName: undefined,
  formFieldInputPlaceholder__backupCode: 'Masukkan kod sandaran',
  formFieldInputPlaceholder__confirmDeletionUserAccount: 'Padam akaun',
  formFieldInputPlaceholder__emailAddress: 'Masukkan alamat e-mel anda',
  formFieldInputPlaceholder__emailAddress_username: 'Masukkan e-mel atau nama pengguna',
  formFieldInputPlaceholder__emailAddresses: 'contoh@emel.com, contoh2@emel.com',
  formFieldInputPlaceholder__firstName: 'Nama pertama',
  formFieldInputPlaceholder__lastName: 'Nama terakhir',
  formFieldInputPlaceholder__organizationDomain: 'contoh.com',
  formFieldInputPlaceholder__organizationDomainEmailAddress: 'anda@contoh.com',
  formFieldInputPlaceholder__organizationName: 'Nama organisasi',
  formFieldInputPlaceholder__organizationSlug: 'organisasi-saya',
  formFieldInputPlaceholder__password: 'Masukkan kata laluan anda',
  formFieldInputPlaceholder__phoneNumber: 'Masukkan nombor telefon anda',
  formFieldInputPlaceholder__username: undefined,
  formFieldLabel__apiKeyDescription: undefined,
  formFieldLabel__apiKeyExpiration: undefined,
  formFieldLabel__apiKeyName: undefined,
  formFieldLabel__automaticInvitations: 'Aktifkan jemputan automatik untuk domain ini',
  formFieldLabel__backupCode: 'Kod sandaran',
  formFieldLabel__confirmDeletion: 'Pengesahan',
  formFieldLabel__confirmPassword: 'Sahkan kata laluan',
  formFieldLabel__currentPassword: 'Kata laluan semasa',
  formFieldLabel__emailAddress: 'Alamat e-mel',
  formFieldLabel__emailAddress_username: 'Alamat e-mel atau nama pengguna',
  formFieldLabel__emailAddresses: 'Alamat e-mel',
  formFieldLabel__firstName: 'Nama pertama',
  formFieldLabel__lastName: 'Nama terakhir',
  formFieldLabel__newPassword: 'Kata laluan baharu',
  formFieldLabel__organizationDomain: 'Domain',
  formFieldLabel__organizationDomainDeletePending: 'Padam jemputan dan cadangan tertunggak',
  formFieldLabel__organizationDomainEmailAddress: 'Alamat e-mel pengesahan',
  formFieldLabel__organizationDomainEmailAddressDescription:
    'Masukkan alamat e-mel di bawah domain ini untuk menerima kod dan mengesahkan domain ini.',
  formFieldLabel__organizationName: 'Nama',
  formFieldLabel__organizationSlug: 'Slug',
  formFieldLabel__passkeyName: 'Nama kunci pas',
  formFieldLabel__password: 'Kata laluan',
  formFieldLabel__phoneNumber: 'Nombor telefon',
  formFieldLabel__role: 'Peranan',
  formFieldLabel__signOutOfOtherSessions: 'Daftar keluar dari semua peranti lain',
  formFieldLabel__username: 'Nama pengguna',
  impersonationFab: {
    action__signOut: 'Daftar keluar',
    title: 'Didaftarkan sebagai {{identifier}}',
  },
  maintenanceMode:
    'Kami sedang menjalani penyelenggaraan, tetapi jangan risau, ini tidak sepatutnya mengambil masa lebih daripada beberapa minit.',
  membershipRole__admin: 'Pentadbir',
  membershipRole__basicMember: 'Ahli',
  membershipRole__guestMember: 'Tetamu',
  organizationList: {
    action__createOrganization: 'Cipta organisasi',
    action__invitationAccept: 'Sertai',
    action__suggestionsAccept: 'Minta untuk menyertai',
    createOrganization: 'Cipta Organisasi',
    invitationAcceptedLabel: 'Disertai',
    subtitle: 'untuk meneruskan ke {{applicationName}}',
    suggestionsAcceptedLabel: 'Menunggu kelulusan',
    title: 'Pilih akaun',
    titleWithoutPersonal: 'Pilih organisasi',
  },
  organizationProfile: {
    apiKeysPage: {
      title: undefined,
    },
    badge__automaticInvitation: 'Jemputan automatik',
    badge__automaticSuggestion: 'Cadangan automatik',
    badge__manualInvitation: 'Tiada pendaftaran automatik',
    badge__unverified: 'Belum disahkan',
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentSourcesSection: {
        actionLabel__default: 'Jadikan lalai',
        actionLabel__remove: 'Keluarkan',
        add: 'Tambah sumber pembayaran baharu',
        addSubtitle: 'Tambah sumber pembayaran baharu ke akaun anda.',
        cancelButton: 'Batal',
        formButtonPrimary__add: 'Tambah Kaedah Pembayaran',
        formButtonPrimary__pay: 'Bayar {{amount}}',
        payWithTestCardButton: undefined,
        removeResource: {
          messageLine1: '{{identifier}} akan dikeluarkan dari akaun ini.',
          messageLine2:
            'Anda tidak akan dapat menggunakan sumber pembayaran ini lagi dan langganan berulang yang bergantung padanya tidak akan berfungsi lagi.',
          successMessage: '{{paymentSource}} telah dikeluarkan dari akaun anda.',
          title: 'Keluarkan sumber pembayaran',
        },
        title: 'Pilihan tersedia',
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: 'Pelan',
        headerTitle__statements: 'Invois',
        headerTitle__subscriptions: undefined,
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: undefined,
      },
      switchPlansSection: {
        title: undefined,
      },
      title: 'Pengebilan & Pembayaran',
    },
    createDomainPage: {
      subtitle:
        'Tambahkan domain untuk pengesahan. Pengguna dengan alamat e-mel di domain ini boleh menyertai organisasi secara automatik atau meminta untuk menyertai.',
      title: 'Tambah domain',
    },
    invitePage: {
      detailsTitle__inviteFailed:
        'Jemputan tidak dapat dihantar. Terdapat jemputan tertunggak untuk alamat e-mel berikut: {{email_addresses}}.',
      formButtonPrimary__continue: 'Hantar jemputan',
      selectDropdown__role: 'Pilih peranan',
      subtitle: 'Masukkan atau tampal satu atau lebih alamat e-mel, dipisahkan oleh ruang atau koma.',
      successMessage: 'Jemputan berjaya dihantar',
      title: 'Jemput ahli baharu',
    },
    membersPage: {
      action__invite: 'Jemput',
      action__search: 'Cari',
      activeMembersTab: {
        menuAction__remove: 'Keluarkan ahli',
        tableHeader__actions: 'Tindakan',
        tableHeader__joined: 'Disertai',
        tableHeader__role: 'Peranan',
        tableHeader__user: 'Pengguna',
      },
      detailsTitle__emptyRow: 'Tiada ahli untuk dipaparkan',
      invitationsTab: {
        autoInvitations: {
          headerSubtitle:
            'Jemput pengguna dengan menghubungkan domain e-mel dengan organisasi anda. Sesiapa yang mendaftar dengan domain e-mel yang sepadan akan dapat menyertai organisasi pada bila-bila masa.',
          headerTitle: 'Jemputan automatik',
          primaryButton: 'Urus domain yang disahkan',
        },
        table__emptyRow: 'Tiada jemputan untuk dipaparkan',
      },
      invitedMembersTab: {
        menuAction__revoke: 'Batal jemputan',
        tableHeader__invited: 'Dijemput',
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle:
            'Pengguna yang mendaftar dengan domain e-mel yang sepadan, akan dapat melihat cadangan untuk meminta untuk menyertai organisasi anda.',
          headerTitle: 'Cadangan automatik',
          primaryButton: 'Urus domain yang disahkan',
        },
        menuAction__approve: 'Lulus',
        menuAction__reject: 'Tolak',
        tableHeader__requested: 'Meminta akses',
        table__emptyRow: 'Tiada permintaan untuk dipaparkan',
      },
      start: {
        headerTitle__invitations: 'Jemputan',
        headerTitle__members: 'Ahli',
        headerTitle__requests: 'Permintaan',
      },
    },
    navbar: {
      apiKeys: undefined,
      billing: 'Pengebilan',
      description: 'Urus organisasi anda.',
      general: 'Am',
      members: 'Ahli',
      title: 'Organisasi',
    },
    plansPage: {
      alerts: {
        noPermissionsToManageBilling: undefined,
      },
      title: undefined,
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Taip "{{organizationName}}" di bawah untuk meneruskan.',
          messageLine1: 'Adakah anda pasti mahu memadam organisasi ini?',
          messageLine2: 'Tindakan ini adalah kekal dan tidak boleh dibatalkan.',
          successMessage: 'Anda telah memadam organisasi.',
          title: 'Padam organisasi',
        },
        leaveOrganization: {
          actionDescription: 'Taip "{{organizationName}}" di bawah untuk meneruskan.',
          messageLine1:
            'Adakah anda pasti mahu meninggalkan organisasi ini? Anda akan kehilangan akses kepada organisasi ini dan aplikasinya.',
          messageLine2: 'Tindakan ini adalah kekal dan tidak boleh dibatalkan.',
          successMessage: 'Anda telah meninggalkan organisasi.',
          title: 'Tinggalkan organisasi',
        },
        title: 'Bahaya',
      },
      domainSection: {
        menuAction__manage: 'Urus',
        menuAction__remove: 'Padam',
        menuAction__verify: 'Sahkan',
        primaryButton: 'Tambah domain',
        subtitle:
          'Benarkan pengguna menyertai organisasi secara automatik atau meminta untuk menyertai berdasarkan domain e-mel yang disahkan.',
        title: 'Domain yang disahkan',
      },
      successMessage: 'Organisasi telah dikemas kini.',
      title: 'Kemas kini profil',
    },
    removeDomainPage: {
      messageLine1: 'Domain e-mel {{domain}} akan dikeluarkan.',
      messageLine2: 'Pengguna tidak akan dapat menyertai organisasi secara automatik selepas ini.',
      successMessage: '{{domain}} telah dikeluarkan.',
      title: 'Keluarkan domain',
    },
    start: {
      headerTitle__general: 'Am',
      headerTitle__members: 'Ahli',
      profileSection: {
        primaryButton: 'Kemas kini profil',
        title: 'Profil Organisasi',
        uploadAction__title: 'Logo',
      },
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: 'Mengeluarkan domain ini akan mempengaruhi pengguna yang dijemput.',
        removeDomainActionLabel__remove: 'Keluarkan domain',
        removeDomainSubtitle: 'Keluarkan domain ini daripada domain yang disahkan anda',
        removeDomainTitle: 'Keluarkan domain',
      },
      enrollmentTab: {
        automaticInvitationOption__description:
          'Pengguna akan dijemput secara automatik untuk menyertai organisasi apabila mereka mendaftar dan boleh menyertai pada bila-bila masa.',
        automaticInvitationOption__label: 'Jemputan automatik',
        automaticSuggestionOption__description:
          'Pengguna menerima cadangan untuk meminta untuk menyertai, tetapi mesti diluluskan oleh pentadbir sebelum mereka dapat menyertai organisasi.',
        automaticSuggestionOption__label: 'Cadangan automatik',
        calloutInfoLabel: 'Mengubah mod pendaftaran hanya akan mempengaruhi pengguna baharu.',
        calloutInvitationCountLabel: 'Jemputan tertunggak yang dihantar kepada pengguna: {{count}}',
        calloutSuggestionCountLabel: 'Cadangan tertunggak yang dihantar kepada pengguna: {{count}}',
        manualInvitationOption__description: 'Pengguna hanya boleh dijemput secara manual ke organisasi.',
        manualInvitationOption__label: 'Tiada pendaftaran automatik',
        subtitle: 'Pilih bagaimana pengguna dari domain ini boleh menyertai organisasi.',
      },
      start: {
        headerTitle__danger: 'Bahaya',
        headerTitle__enrollment: 'Pilihan pendaftaran',
      },
      subtitle: 'Domain {{domain}} kini disahkan. Teruskan dengan memilih mod pendaftaran.',
      title: 'Kemas kini {{domain}}',
    },
    verifyDomainPage: {
      formSubtitle: 'Masukkan kod pengesahan yang dihantar ke alamat e-mel anda',
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Domain {{domainName}} perlu disahkan melalui e-mel.',
      subtitleVerificationCodeScreen:
        'Kod pengesahan telah dihantar ke {{emailAddress}}. Masukkan kod untuk meneruskan.',
      title: 'Sahkan domain',
    },
  },
  organizationSwitcher: {
    action__createOrganization: 'Cipta organisasi',
    action__invitationAccept: 'Sertai',
    action__manageOrganization: 'Urus',
    action__suggestionsAccept: 'Minta untuk menyertai',
    notSelected: 'Tiada organisasi dipilih',
    personalWorkspace: 'Akaun peribadi',
    suggestionsAcceptedLabel: 'Menunggu kelulusan',
  },
  paginationButton__next: 'Seterusnya',
  paginationButton__previous: 'Sebelumnya',
  paginationRowText__displaying: 'Memaparkan',
  paginationRowText__of: 'daripada',
  reverification: {
    alternativeMethods: {
      actionLink: 'Dapatkan bantuan',
      actionText: 'Tidak mempunyai mana-mana ini?',
      blockButton__backupCode: 'Gunakan kod sandaran',
      blockButton__emailCode: 'E-mel kod ke {{identifier}}',
      blockButton__passkey: 'Gunakan kunci pas anda',
      blockButton__password: 'Teruskan dengan kata laluan anda',
      blockButton__phoneCode: 'Hantar kod SMS ke {{identifier}}',
      blockButton__totp: 'Gunakan aplikasi pengesah anda',
      getHelp: {
        blockButton__emailSupport: 'E-mel sokongan',
        content:
          'Jika anda mengalami masalah mengesahkan akaun anda, e-mel kami dan kami akan bekerja dengan anda untuk memulihkan akses secepat mungkin.',
        title: 'Dapatkan bantuan',
      },
      subtitle: 'Menghadapi masalah? Anda boleh menggunakan mana-mana kaedah ini untuk pengesahan.',
      title: 'Gunakan kaedah lain',
    },
    backupCodeMfa: {
      subtitle: 'Masukkan kod sandaran yang anda terima semasa menyediakan pengesahan dua langkah',
      title: 'Masukkan kod sandaran',
    },
    emailCode: {
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Masukkan kod yang dihantar ke e-mel anda untuk meneruskan',
      title: 'Pengesahan diperlukan',
    },
    noAvailableMethods: {
      message: 'Tidak dapat meneruskan pengesahan. Tiada faktor pengesahan yang sesuai dikonfigurasi',
      subtitle: 'Ralat berlaku',
      title: 'Tidak dapat mengesahkan akaun anda',
    },
    passkey: {
      blockButton__passkey: 'Gunakan kunci pas anda',
      subtitle:
        'Menggunakan kunci pas anda mengesahkan identiti anda. Peranti anda mungkin meminta cap jari, wajah, atau kunci skrin anda.',
      title: 'Gunakan kunci pas anda',
    },
    password: {
      actionLink: 'Gunakan kaedah lain',
      subtitle: 'Masukkan kata laluan semasa anda untuk meneruskan',
      title: 'Pengesahan diperlukan',
    },
    phoneCode: {
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Masukkan kod yang dihantar ke telefon anda untuk meneruskan',
      title: 'Pengesahan diperlukan',
    },
    phoneCodeMfa: {
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Masukkan kod yang dihantar ke telefon anda untuk meneruskan',
      title: 'Pengesahan diperlukan',
    },
    totpMfa: {
      formTitle: 'Kod pengesahan',
      subtitle: 'Masukkan kod yang dijana oleh aplikasi pengesah anda untuk meneruskan',
      title: 'Pengesahan diperlukan',
    },
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: 'Tambah akaun',
      action__signOutAll: 'Daftar keluar dari semua akaun',
      subtitle: 'Pilih akaun yang anda ingin teruskan.',
      title: 'Pilih akaun',
    },
    alternativeMethods: {
      actionLink: 'Dapatkan bantuan',
      actionText: 'Tidak mempunyai mana-mana ini?',
      blockButton__backupCode: 'Gunakan kod sandaran',
      blockButton__emailCode: 'E-mel kod ke {{identifier}}',
      blockButton__emailLink: 'E-mel pautan ke {{identifier}}',
      blockButton__passkey: 'Daftar masuk dengan kunci pas anda',
      blockButton__password: 'Daftar masuk dengan kata laluan anda',
      blockButton__phoneCode: 'Hantar kod SMS ke {{identifier}}',
      blockButton__totp: 'Gunakan aplikasi pengesah anda',
      getHelp: {
        blockButton__emailSupport: 'E-mel sokongan',
        content:
          'Jika anda mengalami masalah mendaftar masuk ke akaun anda, e-mel kami dan kami akan bekerja dengan anda untuk memulihkan akses secepat mungkin.',
        title: 'Dapatkan bantuan',
      },
      subtitle: 'Menghadapi masalah? Anda boleh menggunakan mana-mana kaedah ini untuk mendaftar masuk.',
      title: 'Gunakan kaedah lain',
    },
    alternativePhoneCodeProvider: {
      formTitle: undefined,
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    backupCodeMfa: {
      subtitle: 'Kod sandaran anda adalah kod yang anda terima semasa menyediakan pengesahan dua langkah.',
      title: 'Masukkan kod sandaran',
    },
    emailCode: {
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'untuk meneruskan ke {{applicationName}}',
      title: 'Periksa e-mel anda',
    },
    emailLink: {
      clientMismatch: {
        subtitle:
          'Untuk meneruskan, buka pautan pengesahan pada peranti dan pelayar dari mana anda memulakan pendaftaran masuk',
        title: 'Pautan pengesahan tidak sah untuk peranti ini',
      },
      expired: {
        subtitle: 'Kembali ke tab asal untuk meneruskan.',
        title: 'Pautan pengesahan ini telah tamat tempoh',
      },
      failed: {
        subtitle: 'Kembali ke tab asal untuk meneruskan.',
        title: 'Pautan pengesahan ini tidak sah',
      },
      formSubtitle: 'Gunakan pautan pengesahan yang dihantar ke e-mel anda',
      formTitle: 'Pautan pengesahan',
      loading: {
        subtitle: 'Anda akan dialihkan tidak lama lagi',
        title: 'Mendaftar masuk...',
      },
      resendButton: 'Tidak menerima pautan? Hantar semula',
      subtitle: 'untuk meneruskan ke {{applicationName}}',
      title: 'Periksa e-mel anda',
      unusedTab: {
        title: 'Anda boleh menutup tab ini',
      },
      verified: {
        subtitle: 'Anda akan dialihkan tidak lama lagi',
        title: 'Berjaya mendaftar masuk',
      },
      verifiedSwitchTab: {
        subtitle: 'Kembali ke tab asal untuk meneruskan',
        subtitleNewTab: 'Kembali ke tab yang baru dibuka untuk meneruskan',
        titleNewTab: 'Didaftarkan masuk pada tab lain',
      },
    },
    forgotPassword: {
      formTitle: 'Kod tetapan semula kata laluan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'untuk menetapkan semula kata laluan anda',
      subtitle_email: 'Pertama, masukkan kod yang dihantar ke alamat e-mel anda',
      subtitle_phone: 'Pertama, masukkan kod yang dihantar ke telefon anda',
      title: 'Tetapkan semula kata laluan',
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: 'Tetapkan semula kata laluan anda',
      label__alternativeMethods: 'Atau, daftar masuk dengan kaedah lain',
      title: 'Lupa Kata Laluan?',
    },
    noAvailableMethods: {
      message: 'Tidak dapat meneruskan pendaftaran masuk. Tiada faktor pengesahan yang tersedia.',
      subtitle: 'Ralat berlaku',
      title: 'Tidak dapat mendaftar masuk',
    },
    passkey: {
      subtitle:
        'Menggunakan kunci pas anda mengesahkan bahawa itu adalah anda. Peranti anda mungkin meminta cap jari, wajah atau kunci skrin anda.',
      title: 'Gunakan kunci pas anda',
    },
    password: {
      actionLink: 'Gunakan kaedah lain',
      subtitle: 'Masukkan kata laluan yang berkaitan dengan akaun anda',
      title: 'Masukkan kata laluan anda',
    },
    passwordPwned: {
      title: 'Kata laluan dikompromi',
    },
    phoneCode: {
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'untuk meneruskan ke {{applicationName}}',
      title: 'Periksa telefon anda',
    },
    phoneCodeMfa: {
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Untuk meneruskan, sila masukkan kod pengesahan yang dihantar ke telefon anda',
      title: 'Periksa telefon anda',
    },
    resetPassword: {
      formButtonPrimary: 'Tetapkan Semula Kata Laluan',
      requiredMessage: 'Atas sebab keselamatan, adalah diperlukan untuk menetapkan semula kata laluan anda.',
      successMessage: 'Kata laluan anda telah berjaya diubah. Mendaftarkan anda masuk, sila tunggu sebentar.',
      title: 'Tetapkan kata laluan baharu',
    },
    resetPasswordMfa: {
      detailsLabel: 'Kami perlu mengesahkan identiti anda sebelum menetapkan semula kata laluan anda.',
    },
    start: {
      actionLink: 'Daftar',
      actionLink__join_waitlist: 'Sertai senarai menunggu',
      actionLink__use_email: 'Gunakan e-mel',
      actionLink__use_email_username: 'Gunakan e-mel atau nama pengguna',
      actionLink__use_passkey: 'Gunakan kunci pas sebaliknya',
      actionLink__use_phone: 'Gunakan telefon',
      actionLink__use_username: 'Gunakan nama pengguna',
      actionText: 'Tidak mempunyai akaun?',
      actionText__join_waitlist: 'Mahu akses awal?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'Selamat kembali! Sila daftar masuk untuk meneruskan',
      subtitleCombined: undefined,
      title: 'Daftar masuk ke {{applicationName}}',
      titleCombined: 'Teruskan ke {{applicationName}}',
    },
    totpMfa: {
      formTitle: 'Kod pengesahan',
      subtitle: 'Untuk meneruskan, sila masukkan kod pengesahan yang dijana oleh aplikasi pengesah anda',
      title: 'Pengesahan dua langkah',
    },
  },
  signInEnterPasswordTitle: 'Masukkan kata laluan anda',
  signUp: {
    alternativePhoneCodeProvider: {
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    continue: {
      actionLink: 'Daftar masuk',
      actionText: 'Sudah mempunyai akaun?',
      subtitle: 'Sila isi butiran yang tinggal untuk meneruskan.',
      title: 'Isi medan yang hilang',
    },
    emailCode: {
      formSubtitle: 'Masukkan kod pengesahan yang dihantar ke alamat e-mel anda',
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Masukkan kod pengesahan yang dihantar ke e-mel anda',
      title: 'Sahkan e-mel anda',
    },
    emailLink: {
      clientMismatch: {
        subtitle:
          'Untuk meneruskan, buka pautan pengesahan pada peranti dan pelayar dari mana anda memulakan pendaftaran',
        title: 'Pautan pengesahan tidak sah untuk peranti ini',
      },
      formSubtitle: 'Gunakan pautan pengesahan yang dihantar ke alamat e-mel anda',
      formTitle: 'Pautan pengesahan',
      loading: {
        title: 'Mendaftar...',
      },
      resendButton: 'Tidak menerima pautan? Hantar semula',
      subtitle: 'untuk meneruskan ke {{applicationName}}',
      title: 'Sahkan e-mel anda',
      verified: {
        title: 'Berjaya mendaftar',
      },
      verifiedSwitchTab: {
        subtitle: 'Kembali ke tab yang baru dibuka untuk meneruskan',
        subtitleNewTab: 'Kembali ke tab sebelumnya untuk meneruskan',
        title: 'Berjaya mengesahkan e-mel',
      },
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'Saya bersetuju dengan {{ privacyPolicyLink || link("Dasar Privasi") }}',
        label__onlyTermsOfService: 'Saya bersetuju dengan {{ termsOfServiceLink || link("Terma Perkhidmatan") }}',
        label__termsOfServiceAndPrivacyPolicy:
          'Saya bersetuju dengan {{ termsOfServiceLink || link("Terma Perkhidmatan") }} dan {{ privacyPolicyLink || link("Dasar Privasi") }}',
      },
      continue: {
        subtitle: 'Sila baca dan terima terma untuk meneruskan',
        title: 'Persetujuan undang-undang',
      },
    },
    phoneCode: {
      formSubtitle: 'Masukkan kod pengesahan yang dihantar ke nombor telefon anda',
      formTitle: 'Kod pengesahan',
      resendButton: 'Tidak menerima kod? Hantar semula',
      subtitle: 'Masukkan kod pengesahan yang dihantar ke telefon anda',
      title: 'Sahkan telefon anda',
    },
    restrictedAccess: {
      actionLink: 'Daftar masuk',
      actionText: 'Sudah mempunyai akaun?',
      blockButton__emailSupport: 'E-mel sokongan',
      blockButton__joinWaitlist: 'Sertai senarai menunggu',
      subtitle:
        'Pendaftaran kini dilumpuhkan. Jika anda percaya anda sepatutnya mempunyai akses, sila hubungi sokongan.',
      subtitleWaitlist:
        'Pendaftaran kini dilumpuhkan. Untuk menjadi yang pertama tahu bila kami melancarkan, sertai senarai menunggu.',
      title: 'Akses terhad',
    },
    start: {
      actionLink: 'Daftar masuk',
      actionLink__use_email: 'Gunakan e-mel sebaliknya',
      actionLink__use_phone: 'Gunakan telefon sebaliknya',
      actionText: 'Sudah mempunyai akaun?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'Selamat datang! Sila isi butiran untuk memulakan.',
      subtitleCombined: 'Selamat datang! Sila isi butiran untuk memulakan.',
      title: 'Cipta akaun anda',
      titleCombined: 'Cipta akaun anda',
    },
  },
  socialButtonsBlockButton: 'Teruskan dengan {{provider|titleize}}',
  socialButtonsBlockButtonManyInView: '{{provider|titleize}}',
  unstable__errors: {
    already_a_member_in_organization: '{{email}} sudah menjadi ahli organisasi.',
    captcha_invalid:
      'Pendaftaran tidak berjaya kerana pengesahan keselamatan gagal. Sila muat semula halaman untuk mencuba lagi atau hubungi sokongan untuk bantuan lebih lanjut.',
    captcha_unavailable:
      'Pendaftaran tidak berjaya kerana pengesahan bot gagal. Sila muat semula halaman untuk mencuba lagi atau hubungi sokongan untuk bantuan lebih lanjut.',
    form_code_incorrect: undefined,
    form_identifier_exists__email_address: 'Alamat e-mel ini telah diambil. Sila cuba yang lain.',
    form_identifier_exists__phone_number: 'Nombor telefon ini telah diambil. Sila cuba yang lain.',
    form_identifier_exists__username: 'Nama pengguna ini telah diambil. Sila cuba yang lain.',
    form_identifier_not_found: 'Tiada akaun dijumpai dengan pengenal ini. Sila periksa dan cuba lagi.',
    form_param_format_invalid:
      'Nilai yang dimasukkan adalah dalam format yang tidak sah. Sila periksa dan betulkannya.',
    form_param_format_invalid__email_address: 'Alamat e-mel mestilah alamat e-mel yang sah.',
    form_param_format_invalid__phone_number: 'Nombor telefon mestilah dalam format antarabangsa yang sah.',
    form_param_max_length_exceeded__first_name: 'Nama pertama tidak boleh melebihi 256 aksara.',
    form_param_max_length_exceeded__last_name: 'Nama terakhir tidak boleh melebihi 256 aksara.',
    form_param_max_length_exceeded__name: 'Nama tidak boleh melebihi 256 aksara.',
    form_param_nil: 'Medan ini diperlukan dan tidak boleh kosong.',
    form_param_type_invalid: undefined,
    form_param_type_invalid__email_address: undefined,
    form_param_type_invalid__phone_number: undefined,
    form_param_value_invalid: 'Nilai yang dimasukkan tidak sah. Sila betulkannya.',
    form_password_incorrect: 'Kata laluan yang anda masukkan tidak betul. Sila cuba lagi.',
    form_password_length_too_short: 'Kata laluan anda terlalu pendek. Ia mesti sekurang-kurangnya 8 aksara panjang.',
    form_password_not_strong_enough: 'Kata laluan anda tidak cukup kuat.',
    form_password_pwned:
      'Kata laluan ini telah dijumpai sebagai sebahagian daripada pelanggaran dan tidak boleh digunakan, sila cuba kata laluan lain.',
    form_password_pwned__sign_in:
      'Kata laluan ini telah dijumpai sebagai sebahagian daripada pelanggaran dan tidak boleh digunakan, sila tetapkan semula kata laluan anda.',
    form_password_size_in_bytes_exceeded:
      'Kata laluan anda telah melebihi bilangan maksimum bait yang dibenarkan, sila pendekkannya atau keluarkan beberapa aksara khas.',
    form_password_validation_failed: 'Kata Laluan Tidak Betul',
    form_username_invalid_character:
      'Nama pengguna anda mengandungi aksara yang tidak sah. Sila gunakan hanya huruf, nombor, dan garis bawah.',
    form_username_invalid_length:
      'Nama pengguna anda mestilah antara {{min_length}} dan {{max_length}} aksara panjang.',
    identification_deletion_failed: 'Anda tidak boleh memadamkan pengenalan terakhir anda.',
    not_allowed_access:
      'Anda tidak mempunyai kebenaran untuk mengakses halaman ini. Sila hubungi sokongan jika anda percaya ini adalah kesilapan.',
    organization_domain_blocked: 'Ini adalah domain pembekal e-mel yang disekat. Sila gunakan yang berbeza.',
    organization_domain_common: 'Ini adalah domain pembekal e-mel biasa. Sila gunakan yang berbeza.',
    organization_domain_exists_for_enterprise_connection: 'Domain ini sudah digunakan untuk SSO organisasi anda',
    organization_membership_quota_exceeded:
      'Anda telah mencapai had keahlian organisasi anda, termasuk jemputan tertunggak.',
    organization_minimum_permissions_needed:
      'Mesti ada sekurang-kurangnya satu ahli organisasi dengan kebenaran minimum yang diperlukan.',
    passkey_already_exists: 'Kunci pas sudah didaftarkan dengan peranti ini.',
    passkey_not_supported: 'Kunci pas tidak disokong pada peranti ini.',
    passkey_pa_not_supported: 'Pendaftaran memerlukan pengesah platform tetapi peranti tidak menyokongnya.',
    passkey_registration_cancelled: 'Pendaftaran kunci pas dibatalkan atau tamat masa.',
    passkey_retrieval_cancelled: 'Pengesahan kunci pas dibatalkan atau tamat masa.',
    passwordComplexity: {
      maximumLength: 'kurang daripada {{length}} aksara',
      minimumLength: '{{length}} atau lebih aksara',
      requireLowercase: 'huruf kecil',
      requireNumbers: 'nombor',
      requireSpecialCharacter: 'aksara khas',
      requireUppercase: 'huruf besar',
      sentencePrefix: 'Kata laluan anda mesti mengandungi',
    },
    phone_number_exists: 'Nombor telefon ini telah diambil. Sila cuba yang lain.',
    session_exists: undefined,
    web3_missing_identifier: 'Sambungan Dompet Web3 tidak dapat dijumpai. Sila pasang satu untuk meneruskan.',
    zxcvbn: {
      couldBeStronger: 'Kata laluan anda berfungsi, tetapi boleh lebih kuat. Cuba tambah lebih banyak aksara.',
      goodPassword: 'Kata laluan anda memenuhi semua keperluan yang diperlukan.',
      notEnough: 'Kata laluan anda tidak cukup kuat.',
      suggestions: {
        allUppercase: 'Gunakan huruf besar untuk sebahagian, tetapi bukan semua huruf.',
        anotherWord: 'Tambah lebih banyak perkataan yang kurang biasa.',
        associatedYears: 'Elakkan tahun yang berkaitan dengan anda.',
        capitalization: 'Gunakan huruf besar lebih daripada huruf pertama.',
        dates: 'Elakkan tarikh dan tahun yang berkaitan dengan anda.',
        l33t: "Elakkan penggantian huruf yang boleh diramal seperti '@' untuk 'a'.",
        longerKeyboardPattern: 'Gunakan corak papan kekunci yang lebih panjang dan tukar arah menaip beberapa kali.',
        noNeed: 'Anda boleh mencipta kata laluan yang kuat tanpa menggunakan simbol, nombor, atau huruf besar.',
        pwned: 'Jika anda menggunakan kata laluan ini di tempat lain, anda harus mengubahnya.',
        recentYears: 'Elakkan tahun terkini.',
        repeated: 'Elakkan perkataan dan aksara yang berulang.',
        reverseWords: 'Elakkan ejaan terbalik perkataan biasa.',
        sequences: 'Elakkan urutan aksara biasa.',
        useWords: 'Gunakan beberapa perkataan, tetapi elakkan frasa biasa.',
      },
      warnings: {
        common: 'Ini adalah kata laluan yang biasa digunakan.',
        commonNames: 'Nama dan nama keluarga biasa mudah diteka.',
        dates: 'Tarikh mudah diteka.',
        extendedRepeat: 'Corak aksara berulang seperti "abcabcabc" mudah diteka.',
        keyPattern: 'Corak papan kekunci pendek mudah diteka.',
        namesByThemselves: 'Nama tunggal atau nama keluarga mudah diteka.',
        pwned: 'Kata laluan anda telah terdedah oleh pelanggaran data di Internet.',
        recentYears: 'Tahun terkini mudah diteka.',
        sequences: 'Urutan aksara biasa seperti "abc" mudah diteka.',
        similarToCommon: 'Ini serupa dengan kata laluan yang biasa digunakan.',
        simpleRepeat: 'Aksara berulang seperti "aaa" mudah diteka.',
        straightRow: 'Baris lurus kekunci pada papan kekunci anda mudah diteka.',
        topHundred: 'Ini adalah kata laluan yang sering digunakan.',
        topTen: 'Ini adalah kata laluan yang sangat digunakan.',
        userInputs: 'Tidak sepatutnya ada data peribadi atau berkaitan halaman.',
        wordByItself: 'Perkataan tunggal mudah diteka.',
      },
    },
  },
  userButton: {
    action__addAccount: 'Tambah akaun',
    action__manageAccount: 'Urus akaun',
    action__signOut: 'Daftar keluar',
    action__signOutAll: 'Daftar keluar dari semua akaun',
  },
  userProfile: {
    apiKeysPage: {
      title: undefined,
    },
    backupCodePage: {
      actionLabel__copied: 'Disalin!',
      actionLabel__copy: 'Salin semua',
      actionLabel__download: 'Muat turun .txt',
      actionLabel__print: 'Cetak',
      infoText1: 'Kod sandaran akan diaktifkan untuk akaun ini.',
      infoText2:
        'Simpan kod sandaran dengan selamat dan rahsia. Anda boleh menjana semula kod sandaran jika anda mengesyaki ia telah dikompromi.',
      subtitle__codelist: 'Simpan dengan selamat dan rahsia.',
      successMessage:
        'Kod sandaran kini diaktifkan. Anda boleh menggunakan salah satu daripadanya untuk mendaftar masuk ke akaun anda, jika anda kehilangan akses ke peranti pengesahan anda. Setiap kod hanya boleh digunakan sekali.',
      successSubtitle:
        'Anda boleh menggunakan salah satu daripadanya untuk mendaftar masuk ke akaun anda, jika anda kehilangan akses ke peranti pengesahan anda.',
      title: 'Tambah pengesahan kod sandaran',
      title__codelist: 'Kod sandaran',
    },
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentSourcesSection: {
        actionLabel__default: 'Jadikan lalai',
        actionLabel__remove: 'Keluarkan',
        add: 'Tambah sumber pembayaran baharu',
        addSubtitle: 'Tambah sumber pembayaran baharu ke akaun anda.',
        cancelButton: 'Batal',
        formButtonPrimary__add: 'Tambah Kaedah Pembayaran',
        formButtonPrimary__pay: 'Bayar {{amount}}',
        payWithTestCardButton: undefined,
        removeResource: {
          messageLine1: '{{identifier}} akan dikeluarkan dari akaun ini.',
          messageLine2:
            'Anda tidak akan dapat menggunakan sumber pembayaran ini lagi dan langganan berulang yang bergantung padanya tidak akan berfungsi lagi.',
          successMessage: '{{paymentSource}} telah dikeluarkan dari akaun anda.',
          title: 'Keluarkan sumber pembayaran',
        },
        title: 'Pilihan tersedia',
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: 'Pelan',
        headerTitle__statements: 'Invois',
        headerTitle__subscriptions: undefined,
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: undefined,
      },
      switchPlansSection: {
        title: undefined,
      },
      title: undefined,
    },
    connectedAccountPage: {
      formHint: 'Pilih pembekal untuk menghubungkan akaun anda.',
      formHint__noAccounts: 'Tiada pembekal akaun luaran yang tersedia.',
      removeResource: {
        messageLine1: '{{identifier}} akan dikeluarkan dari akaun ini.',
        messageLine2:
          'Anda tidak akan dapat menggunakan akaun yang dihubungkan ini lagi dan ciri-ciri yang bergantung padanya tidak akan berfungsi lagi.',
        successMessage: '{{connectedAccount}} telah dikeluarkan dari akaun anda.',
        title: 'Keluarkan akaun yang dihubungkan',
      },
      socialButtonsBlockButton: '{{provider|titleize}}',
      successMessage: 'Pembekal telah ditambah ke akaun anda',
      title: 'Tambah akaun yang dihubungkan',
    },
    deletePage: {
      actionDescription: 'Taip "Delete account" di bawah untuk meneruskan.',
      confirm: 'Padam akaun',
      messageLine1: 'Adakah anda pasti mahu memadam akaun anda?',
      messageLine2: 'Tindakan ini adalah kekal dan tidak boleh dibatalkan.',
      title: 'Padam akaun',
    },
    emailAddressPage: {
      emailCode: {
        formHint: 'E-mel yang mengandungi kod pengesahan akan dihantar ke alamat e-mel ini.',
        formSubtitle: 'Masukkan kod pengesahan yang dihantar ke {{identifier}}',
        formTitle: 'Kod pengesahan',
        resendButton: 'Tidak menerima kod? Hantar semula',
        successMessage: 'E-mel {{identifier}} telah ditambah ke akaun anda.',
      },
      emailLink: {
        formHint: 'E-mel yang mengandungi pautan pengesahan akan dihantar ke alamat e-mel ini.',
        formSubtitle: 'Klik pada pautan pengesahan dalam e-mel yang dihantar ke {{identifier}}',
        formTitle: 'Pautan pengesahan',
        resendButton: 'Tidak menerima pautan? Hantar semula',
        successMessage: 'E-mel {{identifier}} telah ditambah ke akaun anda.',
      },
      enterpriseSSOLink: {
        formButton: 'Klik untuk mendaftar masuk',
        formSubtitle: 'Selesaikan pendaftaran masuk dengan {{identifier}}',
      },
      formHint: 'Anda perlu mengesahkan alamat e-mel ini sebelum ia boleh ditambah ke akaun anda.',
      removeResource: {
        messageLine1: '{{identifier}} akan dikeluarkan dari akaun ini.',
        messageLine2: 'Anda tidak akan dapat mendaftar masuk menggunakan alamat e-mel ini lagi.',
        successMessage: '{{emailAddress}} telah dikeluarkan dari akaun anda.',
        title: 'Keluarkan alamat e-mel',
      },
      title: 'Tambah alamat e-mel',
      verifyTitle: 'Sahkan alamat e-mel',
    },
    formButtonPrimary__add: 'Tambah',
    formButtonPrimary__continue: 'Teruskan',
    formButtonPrimary__finish: 'Selesai',
    formButtonPrimary__remove: 'Keluarkan',
    formButtonPrimary__save: 'Simpan',
    formButtonReset: 'Batal',
    mfaPage: {
      formHint: 'Pilih kaedah untuk ditambah.',
      title: 'Tambah pengesahan dua langkah',
    },
    mfaPhoneCodePage: {
      backButton: 'Gunakan nombor sedia ada',
      primaryButton__addPhoneNumber: 'Tambah nombor telefon',
      removeResource: {
        messageLine1: '{{identifier}} tidak akan menerima kod pengesahan lagi semasa mendaftar masuk.',
        messageLine2: 'Akaun anda mungkin tidak selamat. Adakah anda pasti mahu meneruskan?',
        successMessage: 'Pengesahan dua langkah kod SMS telah dikeluarkan untuk {{mfaPhoneCode}}',
        title: 'Keluarkan pengesahan dua langkah',
      },
      subtitle__availablePhoneNumbers:
        'Pilih nombor telefon sedia ada untuk mendaftar untuk pengesahan dua langkah kod SMS atau tambah yang baharu.',
      subtitle__unavailablePhoneNumbers:
        'Tiada nombor telefon yang tersedia untuk mendaftar untuk pengesahan dua langkah kod SMS, sila tambah yang baharu.',
      successMessage1:
        'Semasa mendaftar masuk, anda perlu memasukkan kod pengesahan yang dihantar ke nombor telefon ini sebagai langkah tambahan.',
      successMessage2:
        'Simpan kod sandaran ini dan simpan di tempat yang selamat. Jika anda kehilangan akses ke peranti pengesahan anda, anda boleh menggunakan kod sandaran untuk mendaftar masuk.',
      successTitle: 'Pengesahan kod SMS diaktifkan',
      title: 'Tambah pengesahan kod SMS',
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: 'Imbas kod QR sebaliknya',
        buttonUnableToScan__nonPrimary: 'Tidak dapat mengimbas kod QR?',
        infoText__ableToScan:
          'Sediakan kaedah pendaftaran masuk baharu dalam aplikasi pengesah anda dan imbas kod QR berikut untuk menghubungkannya ke akaun anda.',
        infoText__unableToScan:
          'Sediakan kaedah pendaftaran masuk baharu dalam pengesah anda dan masukkan Kunci yang diberikan di bawah.',
        inputLabel__unableToScan1:
          'Pastikan Kata laluan Berasaskan Masa atau Sekali diaktifkan, kemudian selesaikan menghubungkan akaun anda.',
        inputLabel__unableToScan2:
          'Secara alternatif, jika pengesah anda menyokong URI TOTP, anda juga boleh menyalin URI penuh.',
      },
      removeResource: {
        messageLine1: 'Kod pengesahan dari pengesah ini tidak lagi diperlukan semasa mendaftar masuk.',
        messageLine2: 'Akaun anda mungkin tidak selamat. Adakah anda pasti mahu meneruskan?',
        successMessage: 'Pengesahan dua langkah melalui aplikasi pengesah telah dikeluarkan.',
        title: 'Keluarkan pengesahan dua langkah',
      },
      successMessage:
        'Pengesahan dua langkah kini diaktifkan. Semasa mendaftar masuk, anda perlu memasukkan kod pengesahan dari pengesah ini sebagai langkah tambahan.',
      title: 'Tambah aplikasi pengesah',
      verifySubtitle: 'Masukkan kod pengesahan yang dijana oleh pengesah anda',
      verifyTitle: 'Kod pengesahan',
    },
    mobileButton__menu: 'Menu',
    navbar: {
      account: 'Profil',
      apiKeys: undefined,
      billing: 'Pengebilan',
      description: 'Urus maklumat akaun anda.',
      security: 'Keselamatan',
      title: 'Akaun',
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: '{{name}} akan dikeluarkan dari akaun ini.',
        title: 'Keluarkan kunci pas',
      },
      subtitle__rename: 'Anda boleh mengubah nama kunci pas untuk memudahkan carian.',
      title__rename: 'Namakan Semula Kunci Pas',
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions:
        'Adalah disyorkan untuk mendaftar keluar dari semua peranti lain yang mungkin telah menggunakan kata laluan lama anda.',
      readonly:
        'Kata laluan anda pada masa ini tidak boleh disunting kerana anda hanya boleh mendaftar masuk melalui sambungan perusahaan.',
      successMessage__set: 'Kata laluan anda telah ditetapkan.',
      successMessage__signOutOfOtherSessions: 'Semua peranti lain telah didaftarkan keluar.',
      successMessage__update: 'Kata laluan anda telah dikemas kini.',
      title__set: 'Tetapkan kata laluan',
      title__update: 'Kemas kini kata laluan',
    },
    phoneNumberPage: {
      infoText:
        'Mesej teks yang mengandungi kod pengesahan akan dihantar ke nombor telefon ini. Kadar mesej dan data mungkin dikenakan.',
      removeResource: {
        messageLine1: '{{identifier}} akan dikeluarkan dari akaun ini.',
        messageLine2: 'Anda tidak akan dapat mendaftar masuk menggunakan nombor telefon ini lagi.',
        successMessage: '{{phoneNumber}} telah dikeluarkan dari akaun anda.',
        title: 'Keluarkan nombor telefon',
      },
      successMessage: '{{identifier}} telah ditambah ke akaun anda.',
      title: 'Tambah nombor telefon',
      verifySubtitle: 'Masukkan kod pengesahan yang dihantar ke {{identifier}}',
      verifyTitle: 'Sahkan nombor telefon',
    },
    plansPage: {
      title: undefined,
    },
    profilePage: {
      fileDropAreaHint: 'Saiz yang disyorkan 1:1, sehingga 10MB.',
      imageFormDestructiveActionSubtitle: 'Keluarkan',
      imageFormSubtitle: 'Muat naik',
      imageFormTitle: 'Imej profil',
      readonly: 'Maklumat profil anda telah disediakan oleh sambungan perusahaan dan tidak boleh disunting.',
      successMessage: 'Profil anda telah dikemas kini.',
      title: 'Kemas kini profil',
    },
    start: {
      activeDevicesSection: {
        destructiveAction: 'Daftar keluar dari peranti',
        title: 'Peranti aktif',
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: 'Sambung semula',
        actionLabel__reauthorize: 'Benarkan sekarang',
        destructiveActionTitle: 'Keluarkan',
        primaryButton: 'Sambung akaun',
        subtitle__disconnected: 'Akaun ini telah diputuskan sambungan.',
        subtitle__reauthorize:
          'Skop yang diperlukan telah dikemas kini, dan anda mungkin mengalami fungsi terhad. Sila benarkan semula aplikasi ini untuk mengelakkan sebarang masalah',
        title: 'Akaun yang disambungkan',
      },
      dangerSection: {
        deleteAccountButton: 'Padam akaun',
        title: 'Padam akaun',
      },
      emailAddressesSection: {
        destructiveAction: 'Keluarkan e-mel',
        detailsAction__nonPrimary: 'Tetapkan sebagai utama',
        detailsAction__primary: 'Selesaikan pengesahan',
        detailsAction__unverified: 'Sahkan',
        primaryButton: 'Tambah alamat e-mel',
        title: 'Alamat e-mel',
      },
      enterpriseAccountsSection: {
        title: 'Akaun perusahaan',
      },
      headerTitle__account: 'Butiran profil',
      headerTitle__security: 'Keselamatan',
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: 'Jana semula',
          headerTitle: 'Kod sandaran',
          subtitle__regenerate:
            'Dapatkan set kod sandaran yang baharu dan selamat. Kod sandaran sebelumnya akan dipadamkan dan tidak boleh digunakan.',
          title__regenerate: 'Jana semula kod sandaran',
        },
        phoneCode: {
          actionLabel__setDefault: 'Tetapkan sebagai lalai',
          destructiveActionLabel: 'Keluarkan',
        },
        primaryButton: 'Tambah pengesahan dua langkah',
        title: 'Pengesahan dua langkah',
        totp: {
          destructiveActionTitle: 'Keluarkan',
          headerTitle: 'Aplikasi pengesah',
        },
      },
      passkeysSection: {
        menuAction__destructive: 'Keluarkan',
        menuAction__rename: 'Namakan semula',
        primaryButton: 'Tambah kunci pas',
        title: 'Kunci pas',
      },
      passwordSection: {
        primaryButton__setPassword: 'Tetapkan kata laluan',
        primaryButton__updatePassword: 'Kemas kini kata laluan',
        title: 'Kata laluan',
      },
      phoneNumbersSection: {
        destructiveAction: 'Keluarkan nombor telefon',
        detailsAction__nonPrimary: 'Tetapkan sebagai utama',
        detailsAction__primary: 'Selesaikan pengesahan',
        detailsAction__unverified: 'Sahkan nombor telefon',
        primaryButton: 'Tambah nombor telefon',
        title: 'Nombor telefon',
      },
      profileSection: {
        primaryButton: 'Kemas kini profil',
        title: 'Profil',
      },
      usernameSection: {
        primaryButton__setUsername: 'Tetapkan nama pengguna',
        primaryButton__updateUsername: 'Kemas kini nama pengguna',
        title: 'Nama pengguna',
      },
      web3WalletsSection: {
        destructiveAction: 'Keluarkan dompet',
        detailsAction__nonPrimary: 'Tetapkan sebagai utama',
        primaryButton: 'Sambung dompet',
        title: 'Dompet web3',
      },
    },
    usernamePage: {
      successMessage: 'Nama pengguna anda telah dikemas kini.',
      title__set: 'Tetapkan nama pengguna',
      title__update: 'Kemas kini nama pengguna',
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: '{{identifier}} akan dikeluarkan dari akaun ini.',
        messageLine2: 'Anda tidak akan dapat mendaftar masuk menggunakan dompet web3 ini lagi.',
        successMessage: '{{web3Wallet}} telah dikeluarkan dari akaun anda.',
        title: 'Keluarkan dompet web3',
      },
      subtitle__availableWallets: 'Pilih dompet web3 untuk disambungkan ke akaun anda.',
      subtitle__unavailableWallets: 'Tiada dompet web3 yang tersedia.',
      successMessage: 'Dompet telah ditambah ke akaun anda.',
      title: 'Tambah dompet web3',
      web3WalletButtonsBlockButton: '{{provider|titleize}}',
    },
  },
  waitlist: {
    start: {
      actionLink: 'Daftar masuk',
      actionText: 'Sudah mempunyai akses?',
      formButton: 'Sertai senarai menunggu',
      subtitle: 'Masukkan alamat e-mel anda dan kami akan memberitahu anda apabila tempat anda sudah bersedia',
      title: 'Sertai senarai menunggu',
    },
    success: {
      message: 'Anda akan dialihkan tidak lama lagi...',
      subtitle: 'Kami akan menghubungi anda apabila tempat anda sudah bersedia',
      title: 'Terima kasih kerana menyertai senarai menunggu!',
    },
  },
} as const;
